import { action } from 'mobx';
import { API, APIResponse } from '../types';
import { ChannelSchema } from '../../../types/schema';

export class YouTubeAPIController extends API {
  @action
  searchChannels = async (query: string) => {
    const url = `/youtube/channels?q=${query}`;
    const resp = await this.request.get({ url });
    const json = (await resp.json()) as APIResponse<Array<ChannelSchema>>;

    return json;
  };
}
